module.exports = __webpack_public_path__ + "img/Bingo_Info_Game6.5e742adc.png";